// Formatage d'affichage. Une seule implémentation, en `fr-BE` :
// espace insécable comme séparateur de milliers, virgule décimale.
// Rien ici ne calcule — le calcul vit dans shared/pricing.js.

const LOCALE = 'fr-BE';

const euro = new Intl.NumberFormat(LOCALE, {
  style: 'currency',
  currency: 'EUR',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const decimal = new Intl.NumberFormat(LOCALE, {
  minimumFractionDigits: 0,
  maximumFractionDigits: 3,
});

const dateTime = new Intl.DateTimeFormat(LOCALE, { dateStyle: 'short', timeStyle: 'short' });
const dateOnly = new Intl.DateTimeFormat(LOCALE, { dateStyle: 'medium' });

/** Une valeur absente s'affiche « — », JAMAIS « 0,00 € ». */
export function formatEuro(value) {
  if (value === null || value === undefined || value === '') return '—';
  const n = Number(value);
  return Number.isFinite(n) ? euro.format(n) : '—';
}

export function formatNumber(value, unit) {
  if (value === null || value === undefined || value === '') return '—';
  const n = Number(value);
  if (!Number.isFinite(n)) return '—';
  return unit ? `${decimal.format(n)} ${unit}` : decimal.format(n);
}

export function formatPct(value) {
  if (value === null || value === undefined || value === '') return '—';
  const n = Number(value);
  return Number.isFinite(n) ? `${decimal.format(n)} %` : '—';
}

/** Minutes en h:mm — un temps de gamme se lit mieux ainsi. */
export function formatMinutes(value) {
  if (value === null || value === undefined || value === '') return '—';
  const n = Number(value);
  if (!Number.isFinite(n)) return '—';
  if (n < 60) return `${decimal.format(n)} min`;
  const h = Math.floor(n / 60);
  const m = Math.round(n % 60);
  return `${h} h ${String(m).padStart(2, '0')}`;
}

export function formatDate(value) {
  if (!value) return '—';
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? '—' : dateOnly.format(d);
}

export function formatDateTime(value) {
  if (!value) return '—';
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? '—' : dateTime.format(d);
}

/**
 * LE formateur de toute valeur monétaire affichée.
 *
 * Alias explicite de `formatEuro`, nommé pour ce qu'il garantit : un
 * tiret sur l'absence, jamais un zéro. Il existe parce que la règle
 * « zéro n'est pas une estimation » a été écrite trois fois sans jamais
 * prendre — et une règle qui dépend de la vigilance de celui qui code
 * n'est pas une règle, c'est un vœu.
 *
 * Un zéro AFFIRME « c'est gratuit ». Un tiret dit « je ne sais pas ».
 * Sur un devis, la différence se paie.
 */
export const formatEuroOuTiret = formatEuro;

/**
 * Une masse, une longueur, un volume — avec son unité et son tiret.
 *
 * `0` reste affiché quand il est VRAI (une pièce sans sous-traitance
 * coûte réellement 0 € de sous-traitance). Ce qui est interdit, c'est
 * de fabriquer un zéro à partir d'une absence : c'est au producteur de
 * la valeur d'envoyer `null`, et à ce formateur de le rendre visible.
 */
export function formatMesure(value, unit) {
  return formatNumber(value, unit);
}
